"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_interface_1 = require("@ideal-postcodes/core-interface");
var agent_1 = require("./agent");
var Client = /** @class */ (function (_super) {
    __extends(Client, _super);
    /**
     * Client constructor extends CoreInterface
     */
    function Client(config) {
        var _this = this;
        var agent = new agent_1.Agent();
        var header = {};
        var tls = config.tls === undefined ? core_interface_1.TLS : config.tls;
        var baseUrl = config.baseUrl === undefined ? core_interface_1.API_URL : config.baseUrl;
        var version = config.version === undefined ? core_interface_1.VERSION : config.version;
        var strictAuthorisation = config.strictAuthorisation === undefined
            ? core_interface_1.STRICT_AUTHORISATION
            : config.strictAuthorisation;
        var timeout = config.timeout === undefined ? core_interface_1.TIMEOUT : config.timeout;
        var api_key = config.api_key;
        var interfaceConfig = {
            tls: tls,
            api_key: api_key,
            baseUrl: baseUrl,
            version: version,
            strictAuthorisation: strictAuthorisation,
            timeout: timeout,
            header: __assign(__assign({}, header), config.header),
        };
        _this = _super.call(this, __assign({ agent: agent, header: header }, interfaceConfig)) || this;
        return _this;
    }
    return Client;
}(core_interface_1.Client));
exports.Client = Client;
//# sourceMappingURL=client.js.map